export default "__VITE_PUBLIC_ASSET__48c35f9c__"